import { useCallback } from 'react';
import axios, { useApiRequest } from './axios';
import { GetLoginCodeRequest, LoginRequest, TokenRequest } from '../types/auth';

const LOGIN_URL = '/auth/login/';
const TOKEN_URL = '/auth/token/';
const LOGOUT_URL = '/auth/logout/';

/**
 * Ends the session on the server too: revokes the refresh token, which also
 * stops the access tokens minted from it. Best effort - signing out locally
 * never waits for it or fails because of it. Takes the token and workspace as
 * arguments because the caller clears both from storage straight away.
 */
export const revokeSession = (refresh: string, tenantId: string): void => {
  if (!refresh) return;
  axios.post(LOGOUT_URL, { refresh }, { headers: { Tenant: tenantId } }).catch(() => undefined);
};

export const useAuthLoginMutation = () => {
  const { loading, error, executeRequest } = useApiRequest();

  const getCodeMutation = useCallback(async (data: GetLoginCodeRequest): Promise<any | undefined> => {
    const { success } = await executeRequest(() => axios.put(LOGIN_URL, data));
    return { success };
  }, [executeRequest]);

  const loginMutation = useCallback(async (data: LoginRequest): Promise<any | undefined> => {
    const { data: responseData } = await executeRequest(() =>
      axios.post(LOGIN_URL, data)
    );
    return { data: responseData };
  }, [executeRequest]);

  const tokenMutation = useCallback(async (data: TokenRequest): Promise<any | undefined> => {
    const { data: responseData, success } = await executeRequest(() =>
      axios.post(TOKEN_URL, data)
    );
    return { data: responseData, success };
  }, [executeRequest]);

  return { loading, error, getCodeMutation, loginMutation, tokenMutation };
};
